import React from 'react';
import ReactDOM from 'react-dom/client';
import mapboxgl from 'mapbox-gl';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

mapboxgl.workerUrl = '/mapbox-gl-csp-worker.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
